import React from 'react';
import { styled } from '@linaria/react';
import { useTheme } from 'src/theme';


const Textual = styled.p<StyledProps>`
  font-family: ${props => props.theme.fontFamily};
  font-weight:  ${props => props.fontWeight ? props.fontWeight : 'normal'};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  font-size: ${props => props.fontSize ? props.fontSize : props.theme.fontSize.text}px;
  color: ${props => props.color ? props.color : props.theme.colors.grey[500]};
  text-align: ${props => props.align};
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  opacity: ${props => props.disabled ? .3 : 1 };
  letter-spacing: -0.1px;
  @media screen and (min-width: 768px) {
    font-size: ${props => props.fontSize ? props.fontSize : props.fontSizeTablet ? props.fontSizeTablet : props.theme.fontSizeTablet.text}px;
  }
`

interface StyledProps {
  theme?: any;
  color?: string;
  align: string;
  fontWeight?: string | number | undefined;
  fontSize?: number | undefined;
  margin: string | number;
  fontSizeTablet?: string | number;
  disabled?: boolean;
}


export interface TextProps {
  id?: string | undefined;
  className?: string | undefined;
  align: 'center' | 'left' | 'right' | string;
  theme?: any;
  color: string | undefined;
  children?: React.ReactNode;
  fontWeight?: string | number | undefined;
  fontSize?: number | undefined;
  fontSizeTablet?: number | undefined;
  margin: string | number;
  dangerouslySetInnerHTML?: any;
  disabled?: boolean;
}

function Text({ color, children, align, fontWeight, id, className, fontSize, margin, fontSizeTablet, disabled, dangerouslySetInnerHTML }: TextProps) {
  const theme = useTheme();
  return dangerouslySetInnerHTML ?
    <Textual disabled={disabled} dangerouslySetInnerHTML={dangerouslySetInnerHTML} id={id} className={className} fontSize={fontSize} fontSizeTablet={fontSizeTablet} margin={margin} fontWeight={fontWeight} theme={theme} align={align} color={color}></Textual> :
    <Textual disabled={disabled} id={id} className={className} fontSize={fontSize} fontSizeTablet={fontSizeTablet} margin={margin} fontWeight={fontWeight} theme={theme} align={align} color={color}>{children}</Textual>
};

Text.defaultProps = {
  color: undefined,
  align: 'left',
  margin: 0
}

export default Text;
